import { Button, Card, H4, P, Span } from '@dnb/eufemia';
import { lightbulb_medium as LightbulbIcon } from '@dnb/eufemia/icons';
import Markdown from '@portals/shared-frontend/components/Markdown';
import { type JSX } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const CURL_CREATE_API_WITH_API_KEYS = `
\`\`\`bash
curl --location --request POST 'https://api.prod.devportal.tech-03.net/v1/apis' \n \
--header 'X-DNBAPI-Trace-Id: {{trace-id}}' \n \
--header 'Content-Type: application/json' \n \
--header 'x-app-id: {{app-id}}' \n \
--header 'x-api-key: {{api-key}}' \n \
--data '{
    "slug": "<string>",
    "name": "<string>",
    "classification": "<string>",
    "description": "<string>",
    "enableStatus": <bool>
}'
\`\`\`
`;

const CURL_CREATE_API_WITH_OAUTH2 = `
\`\`\`bash
curl --location --request POST 'https://api.prod.devportal.tech-03.net/v1/apis' \n \
--header 'X-DNBAPI-Trace-Id: {{trace-id}}' \n \
--header 'Content-Type: application/json' \n \
--header 'Authorization: Bearer {{accessToken}}' \n \
--header 'x-app-id: {{app-id}}' \n \
--data '{
    "slug": "<string>",
    "name": "<string>",
    "classification": "<string>",
    "description": "<string>",
    "enableStatus": <bool>
}'
\`\`\`
`;

interface Props {
  accessType: 'API_KEYS' | 'O_AUTH_SYSTEM_TO_SYSTEM' | null;
}

export default function GetStartedGuideCard({ accessType }: Props): JSX.Element {
  return (
    <Card direction="vertical" outset={false} stretch>
      <H4>
        <Span right="small">
          <LightbulbIcon />
        </Span>
        Get started with your first API
      </H4>
      <P top="small">
        You have access to the Developer Portal API. How about getting started with publishing your first API?
      </P>

      <Button
        element={RouterLink}
        target="_blank"
        to="/documentation/developer-portal-api/@default/@latest/guide"
        top="small"
        variant="secondary"
      >
        Go to guide
      </Button>
      <P top="small">Example</P>
      <Markdown>{accessType === 'API_KEYS' ? CURL_CREATE_API_WITH_API_KEYS : CURL_CREATE_API_WITH_OAUTH2}</Markdown>
    </Card>
  );
}
